import React, { createContext, useState, useEffect } from "react";
import productData from "../Datas/productData";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    try {
      const savedCartItems = localStorage.getItem("cartItems");
      const parsed = savedCartItems ? JSON.parse(savedCartItems) : [];
      return Array.isArray(parsed)
        ? parsed.filter(({ id }) => productData.some((product) => product.id === id && product.purchasable))
        : [];
    } catch (error) {
      console.error("Failed to parse cart items from localStorage", error);
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("cartItems", JSON.stringify(cartItems));
    } catch (error) {
      console.error("Failed to save cart items to localStorage", error);
    }
  }, [cartItems]);

  const addToCart = (productId, quantity, size, color) => {
    setCartItems((prevItems) => {
      const product = productData.find((item) => item.id === productId);
      if (!product?.purchasable || product.inventory < 1) return prevItems;
      const existingItem = prevItems.find(
        (item) =>
          item.id === productId && item.size === size && item.color === color
      );

      if (existingItem) {
        return prevItems.map((item) =>
          item.id === productId && item.size === size && item.color === color
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      } else {
        const newItem = { id: productId, size, color, quantity };
        return [...prevItems, newItem];
      }
    });
  };

  const removeFromCart = (productId, size, color) => {
    setCartItems((prevItems) =>
      prevItems.filter(
        (item) =>
          !(item.id === productId && item.size === size && item.color === color)
      )
    );
  };

  const updateQuantity = (productId, size, color, quantity) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === productId && item.size === size && item.color === color
          ? { ...item, quantity: Math.max(1, quantity) }
          : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        clearCart,
        updateQuantity,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
